import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function passwordMatchValidator(other: AbstractControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null =>
        control.value === other.value ? null : {passwordMatch: true};
}

export const agreeToTermsValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
    control.value ? null : {agreeToTerms: true};

export function serverRejectedValueValidator(getRejected: () => string | null): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const rejected = getRejected();
        return rejected !== null && control.value === rejected ? {serverRejected: true} : null;
    };
}
